import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punedarshanpackage() {



    const cardData = {

keyword: "Pune Darshan Packages",

headingDescription:
    "Rising Cab Service offers well-planned Pune Darshan Packages for families, tourists, pilgrims, students, and corporate groups looking to explore the cultural and historical attractions of Pune. Our sightseeing packages include comfortable travel in Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles with experienced drivers. Whether you prefer a half-day or full-day city tour, we provide flexible itineraries, affordable pricing, and reliable service to make your Pune sightseeing experience enjoyable and hassle-free.",

topPlaces: [
    {
        title: "Shaniwar Wada",
        description:
            "Shaniwar Wada is the most iconic historical monument in Pune and was the seat of the Peshwa rulers of the Maratha Empire. Built in the 18th century, the fort features massive gates, stone walls, beautiful gardens, and the remains of royal palaces. The evening light and sound show brings the glorious history of the Marathas to life."
    },
    {
        title: "Aga Khan Palace",
        description:
            "Aga Khan Palace is a magnificent heritage monument associated with India's freedom movement. Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters were imprisoned here during the Quit India Movement. The palace is surrounded by beautiful gardens and houses a museum showcasing historical artifacts and photographs."
    },
    {
        title: "Dagadusheth Halwai Ganpati Temple",
        description:
            "One of the most famous Ganesha temples in Maharashtra, Dagadusheth Halwai Ganpati Temple attracts thousands of devotees every day. The beautifully adorned idol of Lord Ganesha and the grand celebrations during Ganesh Chaturthi make it a major spiritual and cultural attraction in Pune."
    },
    {
        title: "Sinhagad Fort",
        description:
            "Sinhagad Fort is a historic hill fort famous for the bravery of Tanaji Malusare and the Maratha Empire. Located amidst the Sahyadri hills, the fort offers breathtaking views, ancient structures, trekking opportunities, and delicious local Maharashtrian cuisine."
    },
    {
        title: "Raja Dinkar Kelkar Museum",
        description:
            "Raja Dinkar Kelkar Museum houses an extensive collection of Indian artifacts including sculptures, musical instruments, traditional weapons, paintings, textiles, and household items. The museum offers visitors an interesting journey through India's rich cultural and artistic heritage."
    },
    {
        title: "Pataleshwar Cave Temple",
        description:
            "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva and dates back to the 8th century. Carved from a single rock, the temple is known for its impressive pillars, peaceful atmosphere, and remarkable ancient architecture."
    },
    {
        title: "Parvati Hill Temple",
        description:
            "Parvati Hill is one of Pune's oldest landmarks and provides spectacular panoramic views of the city. The hill is home to several ancient temples dedicated to Lord Shiva, Goddess Parvati, and other Hindu deities, making it an important spiritual and historical destination."
    },
    {
        title: "Saras Baug",
        description:
            "Saras Baug is a popular garden and recreational spot featuring the famous Siddhivinayak Temple. The beautifully maintained lawns, walking paths, and peaceful surroundings make it an ideal place for families, tourists, and devotees visiting Pune."
    },
    {
        title: "Pune Okayama Friendship Garden",
        description:
            "Inspired by Japanese landscaping, Pune Okayama Friendship Garden is one of the largest Japanese-style gardens in India. Beautiful bridges, waterfalls, green lawns, and colorful flowers create a serene environment for relaxation and photography."
    },
    {
        title: "Khadakwasla Dam",
        description:
            "Khadakwasla Dam is a scenic attraction on the outskirts of Pune, offering beautiful views of the reservoir and surrounding hills. It is a popular picnic destination where visitors can enjoy the natural beauty, local snacks, and refreshing atmosphere, especially during the monsoon season."
    }
],



services: [
    {
        name: "Pune Darshan Packages",
        description:
            "Rising Cab Service offers Pune Darshan Packages for tourists, families, and groups looking to explore the city's famous attractions, temples, historical landmarks, museums, and gardens with comfortable vehicles and professional drivers."
    },
    {
        name: "Pune Darshan Tour Package",
        description:
            "Book Pune Darshan Tour Package with Rising Cab Service for a complete sightseeing experience covering popular destinations across Pune with flexible travel plans and affordable pricing."
    },
    {
        name: "Pune City Darshan Package",
        description:
            "Rising Cab Service provides Pune City Darshan Package for visitors who want to discover Pune's rich culture, heritage sites, religious places, and tourist attractions in a comfortable manner."
    },
    {
        name: "Pune Sightseeing Package",
        description:
            "Our Pune Sightseeing Package includes convenient transportation to major tourist attractions, making local travel easy, comfortable, and enjoyable for all travelers."
    },
    {
        name: "Pune Local Tour Package",
        description:
            "Rising Cab Service offers Pune Local Tour Package with customized routes, experienced drivers, and clean vehicles for city sightseeing and local exploration."
    },
    {
        name: "Pune Darshan Cab Package",
        description:
            "Enjoy a hassle-free Pune Darshan Cab Package with well-maintained cabs, flexible schedules, and experienced drivers for local sightseeing and temple visits."
    },
    {
        name: "Pune Tourist Package",
        description:
            "Rising Cab Service provides Pune Tourist Package designed for individuals, families, and groups seeking a comfortable and memorable travel experience across Pune."
    },
    {
        name: "Pune One Day Darshan Package",
        description:
            "Our Pune One Day Darshan Package covers major tourist attractions and religious sites in a single day with convenient pickup and drop facilities."
    },
    {
        name: "Pune City Tour Package",
        description:
            "Book Pune City Tour Package with Rising Cab Service to explore Pune's historical monuments, famous temples, museums, gardens, and cultural landmarks."
    },
    {
        name: "Pune Sightseeing Tour Package",
        description:
            "Rising Cab Service offers Pune Sightseeing Tour Package for visitors looking for comfortable transportation and organized sightseeing throughout the city."
    },
    {
        name: "Pune Tourist Places Package",
        description:
            "Our Pune Tourist Places Package helps travelers visit the city's most popular attractions with professional drivers and reliable cab services."
    },
    {
        name: "Pune Family Tour Package",
        description:
            "Pune Family Tour Package from Rising Cab Service is ideal for families seeking comfortable travel, spacious vehicles, and customized sightseeing plans."
    },
    {
        name: "Pune Weekend Darshan Package",
        description:
            "Enjoy a relaxing Pune Weekend Darshan Package with convenient cab services covering the city's top attractions and nearby destinations."
    },
    {
        name: "Pune Local Sightseeing Package",
        description:
            "Rising Cab Service provides Pune Local Sightseeing Package for tourists and residents looking to explore Pune comfortably and affordably."
    },
    {
        name: "Pune Full Day Tour Package",
        description:
            "Our Pune Full Day Tour Package offers complete city exploration with flexible schedules, experienced drivers, and comfortable vehicles."
    },
    {
        name: "Pune AC Cab Darshan Package",
        description:
            "Travel comfortably with Pune AC Cab Darshan Package from Rising Cab Service featuring clean air-conditioned vehicles and professional drivers."
    },
    {
        name: "Pune Tourist Cab Package",
        description:
            "Rising Cab Service offers Pune Tourist Cab Package with sedan, SUV, Innova Crysta, and tempo traveller options for all sightseeing requirements."
    }
],

tableData: [
    ["Pune Darshan Packages", "Pune Darshan Tour Package"],
    ["Pune City Darshan Package", "Pune Sightseeing Package"],
    ["Pune Local Tour Package", "Pune Darshan Cab Package"],
    ["Pune Tourist Package", "Pune One Day Darshan Package"],
    ["Pune City Tour Package", "Pune Sightseeing Tour Package"],
    ["Pune Tourist Places Package", "Pune Family Tour Package"],
    ["Pune Weekend Darshan Package", "Pune Local Sightseeing Package"],
    ["Pune Full Day Tour Package", "Pune AC Cab Darshan Package"],
    ["Pune Tourist Cab Package", "Pune Darshan Packages"],
    ["Pune Darshan Tour Package", "Pune City Darshan Package"]
],



whychoose: [
    {
        WhyChooseheading: "Complete Pune Darshan Packages",
        WhyChoosedescription: "Rising Cab Service offers well-organized Pune Darshan Packages covering famous historical sites, temples, museums, gardens, forts, and cultural attractions across the city."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Sightseeing Tours",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, Tempo Travellers, and spacious vehicles that ensure a comfortable and enjoyable Pune sightseeing experience."
    },
    {
        WhyChooseheading: "Customized Pune Tour Itineraries",
        WhyChoosedescription: "We provide flexible Pune Darshan Packages that can be tailored according to your preferred attractions, travel duration, family size, and sightseeing interests."
    },
    {
        WhyChooseheading: "Affordable Pune Sightseeing Packages",
        WhyChoosedescription: "Rising Cab Service offers budget-friendly Pune Darshan Packages with transparent pricing and excellent travel convenience for every traveler."
    },
    {
        WhyChooseheading: "Covering Major Tourist Attractions",
        WhyChoosedescription: "Our Pune Darshan tours include Shaniwar Wada, Aga Khan Palace, Dagdusheth Halwai Ganpati, Saras Baug, Lal Mahal, Pataleshwar Temple, Sinhagad Fort, and many more attractions."
    },
    {
        WhyChooseheading: "Knowledgeable and Professional Drivers",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune's tourist destinations and help travelers enjoy a smooth and well-planned city tour."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "We offer convenient pickup services from Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Pune Airport, and all major Pune locations."
    },
    {
        WhyChooseheading: "Ideal for Families, Tourists & Groups",
        WhyChoosedescription: "Our Pune Darshan Packages are perfect for families, tourists, students, corporate guests, senior citizens, and groups exploring Pune's heritage and culture."
    }
]
};

const faqData = [
    {
        question: "What are Pune Darshan Packages?",
        answer: "Pune Darshan Packages are sightseeing tours designed to help travelers explore Pune's famous historical, cultural, religious, and tourist attractions in a comfortable vehicle."
    },
    {
        question: "Which places are included in Pune Darshan Packages?",
        answer: "Popular attractions include Shaniwar Wada, Aga Khan Palace, Dagdusheth Ganpati, Saras Baug, Lal Mahal, Raja Dinkar Kelkar Museum, Pataleshwar Temple, and Sinhagad Fort."
    },
    {
        question: "Do you provide full-day Pune Darshan Packages?",
        answer: "Yes, Rising Cab Service offers full-day and customized Pune Darshan sightseeing packages."
    },
    {
        question: "Can I customize my Pune Darshan Package?",
        answer: "Yes, travelers can customize their itinerary based on preferred attractions and available time."
    },
    {
        question: "Which vehicles are available for Pune Darshan?",
        answer: "We provide Sedan cars, Ertiga, Innova Crysta, Tempo Travellers, SUVs, and larger vehicles for group sightseeing."
    },
    {
        question: "Are Pune Darshan Packages suitable for families?",
        answer: "Yes, our sightseeing packages are ideal for families, children, senior citizens, and tourist groups."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickup and drop services are available from Pune Airport, Railway Station, hotels, and residential locations."
    },
    {
        question: "How much time is required for Pune Darshan?",
        answer: "A complete Pune Darshan tour generally takes between 6 to 10 hours depending on the selected attractions."
    },
    {
        question: "Do your drivers know the tourist attractions in Pune?",
        answer: "Yes, our drivers have good knowledge of Pune's sightseeing locations and commonly visited tourist spots."
    },
    {
        question: "How can I book a Pune Darshan Package?",
        answer: "You can book your Pune Darshan Package through phone, WhatsApp, or online booking with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Abhijeet Kulkarni",
        feedback:
            "The Pune Darshan Package from Rising Cab Service was well-planned and comfortable. We visited all major attractions without any hassle and enjoyed the entire trip.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Swati Deshpande",
        feedback:
            "Our family had a wonderful Pune sightseeing experience. The vehicle was clean, the driver was helpful, and every destination was covered smoothly throughout the day.",
        rating: 5
    }
];



















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune Darshan Packages",
"image": "https://www.risingcabservice.com/assets/images/pune-darshan-packages.jpg",
"description": "Book Pune Darshan Packages with Rising Cab Service for comfortable city sightseeing, temple visits, heritage tours, and one-day local tours. Enjoy affordable packages with AC cabs, professional drivers, and flexible travel options.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-darshan-packages"
}
};






    return (
        <div>

<Helmet>
  <title>Pune Darshan Packages | City Sightseeing Tour Package | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune Darshan Packages for city sightseeing, temple tours, heritage visits, and full-day tours. Affordable Pune local tour packages with AC cabs and professional drivers for comfortable travel."
/>

<meta
 name="keywords"
 content="Pune Darshan Packages, Pune Darshan Tour Package, Pune City Darshan Package, Pune Sightseeing Package, Pune Local Tour Package, Pune Darshan Cab Package, Pune Tourist Package, Pune One Day Darshan Package, Pune City Tour Package, Pune Sightseeing Tour Package, Pune Tourist Places Package, Pune Family Tour Package, Pune Weekend Darshan Package, Pune Local Sightseeing Package, Pune Full Day Tour Package, Pune AC Cab Darshan Package"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punedarshanpackage;